import React, { useEffect } from 'react';
import DnDContext from '../DnDContext';
import DropArea from '../DropArea';
import common_DnDOverContent from '../common/DnDOverContent'

const ComponentDropArea0 = (props) => {
  const { onDrop, overContent, overContentArg, acceptTypes } = props

  // useEffect(() => {
  //   console.log("test")
  // }, [])
  // useEffect(() => {
  //   console.log("acceptTypes is changed", acceptTypes)
  // }, [acceptTypes])

  return (
    <DnDContext>
      <DropArea 
        onDrop={onDrop}
        overContent={overContent}
        overContentArg={overContentArg}
        acceptTypes={acceptTypes}
      />
    </DnDContext>
  )
}


const common_overContentArg = {
  minHeight: 15
}

export const RenderComponentDropArea0 = (props) => {
  const { onDrop, DnDOverContent, overContentArg, allowed_types } = props
  return (
    <ComponentDropArea0 
      onDrop={onDrop ? onDrop : (e) => {console.log(e)}}
      overContent={DnDOverContent ? DnDOverContent : common_DnDOverContent}
      overContentArg={{...common_overContentArg, ...overContentArg}}
      acceptTypes={allowed_types ? allowed_types : []}
    />
  )
}

export default ComponentDropArea0